<template>
    <div align="center">
        <div class="commonSearch top" ref="commonSearchRef">
            <span>&nbsp;&nbsp;|&nbsp;&nbsp;图表数据</span>
        </div>
        <div class="commonSearch bottom" ref="commonSearchRef">
            <div>
                <el-form class="el-form el-form--inline">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="起始日期:">
                                <el-date-picker v-model="frm.startdate" type="date" @change="datachange()" placeholder="选择日期" :picker-options="pickerOptions1"> </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" style="margin-left: 20px">
                            <el-form-item label="结束日期:">
                                <el-date-picker v-model="frm.enddate" type="date" @change="datachange2()" placeholder="选择日期" :picker-options="pickerOptions2"> </el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="4">
                            <el-button type="primary" @click="find">查询</el-button>
                            <el-button type="primary" plain @click="frm = {}">清空</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <el-main style="height: 100%; padding: 10px 20px 0px 20px; display: flex">
                <div class="untreated-list" ref="untreatedListRef" align="left">
                    <div id="myChart" :style="{ width: '500px', height: '400px' }"></div>
                </div>
                <div class="untreated-list" ref="untreatedListRef" align="left">
                    <div align="center">
                        <p class="list-header-title" style="margin: 15px 0px">
                            报修单总数:({{ this.sum }}单)
                        </p>
                    </div>
                    <div>
                        <el-table :data="returndata" height="353px" ref="datas" element-loading-text="拼命加载中">
                            <el-table-column prop="faulttypeName" label="故障类型" align="center"> </el-table-column>
                            <el-table-column prop="num" label="数量(单)" align="center"> </el-table-column>
                            <el-table-column prop="percentage" label="占比" align="center"> </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-main>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import ReportApi from "@/api/report.js";

export default {
    mixins: [TabResize],
    components: {},

    data () {
        return {
            frm: {
                startdate: "",
                enddate: "",
            },
            returndata: [],
            datacount: "",
            ksdate: "",
            jsdate: "",
            sum: "",
            drawData: [],
            pickerOptions1: {
                disabledDate: (time) => {
                    if (this.frm.enddate != "") {
                        return time.getTime() > new Date(this.frm.enddate).getTime();
                    }
                }
            },
            pickerOptions2: {
                disabledDate: (time) => {
                    return time.getTime() < new Date(this.frm.startdate).getTime();
                }
            }
        };
    },

    mounted: function () {
        let cont;
        for (let i = 0; i < this.returndata.length; i++) {
            this.datacount += parseInt(this.returndata[i].value);
        }
        this.find();
    },

    methods: {
        datachange () {
            this.ksdate = this.$utils.datetimeparse(new Date(this.frm.startdate), "YYYY-MM-DD");
        },
        datachange2 () {
            this.jsdate = this.$utils.datetimeparse(
                new Date(this.frm.enddate),
                "YYYY-MM-DD"
            );
        },

        draw () {
            // 初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById("myChart"));
            // 绘制图表
            var option = {
                tooltip: {
                    //鼠标悬停数据
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                series: [
                    {
                        name: "故障类型",
                        type: "pie",
                        data: this.drawData,
                        color: [
                            "#FE3A64",
                            "#79E454",
                            "#F98D62",
                            "#EEDC82",
                            "#90EE90",
                            "#EED2EE",
                            "#DA70D6",
                            "#63B8FF",
                        ],
                        textStyle: {
                            color: "#000",
                            fontSize: 16,
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        }
                    }
                ]
            };
            //防止越界，重绘canvas
            window.onresize = myChart.resize;
            myChart.setOption(option); //设置option
        },

        find () {
            let param = this.frm;
            ReportApi.getClass()
                .type(param)
                .then((res) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
                        let data = res.data.data;

                        if (this.$utils.isEmpty(data)) {
                            this.returndata = data;
                            this.sum = data[0].sum;
                            this.drawData = this.returndata;
                            this.draw();
                        } else {
                            this.returndata = [];
                            this.drawData = [
                                {
                                    value: 0,
                                    name: "故障类型"
                                }
                            ];
                            this.draw();
                        }
                    } else {
                        this.$message.error(res.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        }
    }
};
</script>

<style lang="stylus" scoped>
.top {
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: left;
    font-size: 18px;
    width: 90%;
    color: #F8F8FF;
    height: 30px;
    background-color: #3D84FF;
}

.bottom {
    width: 90%;
}

.untreated-list {
    width: 100%;
    background-color: #fff;

    .list-header {
        height: 40px;
        padding-top: 20px;

        .list-header-title {
            float: left;
            height: 23px;
            margin-left: 22px;
            margin-top: 10px;
            font-size: 15px;
            font-weight: 400;
            color: #282D32;
            line-height: 20px;
        }
    }
}
</style>